<template>
    <div>
        <el-row class="cnt-wrapper">
            <el-col :span="6">
                <div class="dept-side">
                    <el-row class="dept-side-hd">
                        <el-col :span="12">业务员</el-col>
                    </el-row>
                    <el-table ref="areaTable" highlight-current-row v-loading="loading" max-height="700" :data="list" style="width: 100%" @row-click="showView" height="700">
                        <el-table-column prop="user_name"></el-table-column>
                        <el-table-column width="40">
                            <template slot-scope="scope">
                                <i class="el-icon-delete" @click="handleDelete(scope.row)"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-row class="searchSection">
                        <el-col :span="4" :offset="10">
                            <el-button type="text" size="medium" @click="handleCreate">+新增</el-button>
                        </el-col>
                    </el-row>
                </div> 
            </el-col>
            <el-col :span="18">
                <div class="staff-main-content" style="border:1px solid #dcdcdc" v-loading="loading">
                    <el-row class="staff-main-title clearfix">
                        <el-col :span="22">区域绑定{{form.id > 0 ? '-编辑' : '-新增'}}</el-col>
                        <el-col :span="2">
                            <el-button type="text" size="medium" @click="resetForm">刷新</el-button>
                        </el-col>
                    </el-row>
                    <br><br>
                    <el-row class="staff-main-item">
                        <el-form ref="form" :model="form" :rules="rules">
                            <el-form-item prop="user_id" label="业务员">
                                <el-select v-model="form.user_id" filterable placeholder="请选择" style="width:80%" :key="form.id">
                                    <el-option
                                            v-for="item in users"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id + ''"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-row>
                    <el-row class="staff-main-item">
                        <p>
                            <AreaTree :checked_ids="form.district_ids" @change="areaTreeChange" key="1"></AreaTree>
                            <el-button type="warning" @click="lockAllAreas"><i class="el-icon-fa-lock"></i> 锁定所有区域</el-button>
                            <el-button type="success" @click="unlockAllAreas"><i class="el-icon-fa-key"></i> 解锁所有区域</el-button>
                            <!-- <AreaGroupLog :area_group_id="form.id">查看线索分配日志</AreaGroupLog> -->
                        </p>
                        <el-alert
                            title="温馨提示"
                            type="info"
                            description="带 图标 🔒 的区域为锁定区域，被锁定的区域的客户除了当前用户其他用户将无法绑定，点击单个区域标签可对其进行锁定&解锁操作">
                        </el-alert>
                        <el-table
                        :loading="loading"
                        :data="areas"
                        border
                        max-height="350">
                            <el-table-column label="所属省市" width="180">
                                <template slot-scope="scope">
                                    {{scope.row.province_name}}/{{scope.row.city_name}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="address" label="已绑定业务区域">
                                <template slot-scope="scope" >
                                    <a>
                                        <el-tag
                                            class="areaTag"
                                            v-for="area in scope.row.districts"
                                            :key="area.district_id"
                                            @click="handleLock(area)"
                                            closable
                                            @close="unbindDistrict(area.district_id)"
                                        >
                                            <i v-if="area.is_lock == 1" class="el-icon-fa-lock"></i> {{area.district_name}}
                                        </el-tag>
                                    </a>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                    <el-row class="staff-main-item">
                        <p>
                            <AreaTree :checked_ids="form.common_district_ids" @change="commonAreaTreeChange" button_name="绑定公海池" button_type="primary" key="2"></AreaTree>
                        </p>
                        <el-alert
                            title="温馨提示"
                            type="info"
                            description="绑定公海池后，业务员只能看到绑定区域的可领取客户">
                        </el-alert>
                        <el-table
                        :loading="loading"
                        :data="common_areas"
                        border
                        max-height="350">
                            <el-table-column label="所属省市" width="180">
                                <template slot-scope="scope">
                                    {{scope.row.province_name}}/{{scope.row.city_name}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="address" label="已绑定业务区域">
                                <template slot-scope="scope" >
                                    <a>
                                        <el-tag
                                            class="areaTag"
                                            v-for="area in scope.row.commonDistricts"
                                            :key="area.district_id"
                                            closable
                                            @close="unbindCommonDistrict(area.district_id)"
                                        >
                                        {{area.district_name}}
                                        </el-tag>
                                    </a>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                    <el-row class="staff-main-btn">
                        <el-col :span="4" :offset="10">
                            <el-button type="primary" size="medium" @click="handleSave" :loading="submiting">保存</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<style scoped>
</style>
<script>
    import UserService from "~/services/user";
    import AreaUserService from "~/services/AreaUser";
    import AreaTree from "~/views/user/dialog/areaTree.vue";
    export default {
        name: "AreaUser",
        components: {
            AreaTree,
        },
        data() {
            return {
                form: {
                    id: '',
                    districts: [],
                    district_ids: [],
                    commonDistricts: [],
                    common_district_ids: [],
                    user_id: '',
                },
                rules: {
                    user_id: [
                        {
                            required: true,
                            message: "请选择业务员",
                            trigger: 'blur'
                        }
                    ]
                },
                loading: false, 
                list: [],
                users: [],
                searcheModel: {},
                dialogFormVisible: false,
                submiting: false,
            }
        },
        created: function () {
            this.resetForm();
            this.getSelectOptions();
        },
        
        computed: {
            areas() {
                if (!this.form.districts || this.form.districts.length === 0) {
                    return [];
                }
                return this.form.districts.reduce((acc, current) => {
                    const existingCity = acc.find(item => item.city_id === current.city_id);
                    if (existingCity) {
                        existingCity.districts.push(current);
                    } else {
                        acc.push({
                        province_id: current.province_id,
                        province_name: current.province_name,
                        city_id: current.city_id,
                        city_name: current.city_name,
                        districts: [current],
                        });
                    }
                    return acc;
                }, []);
            },
            common_areas() {
                if (!this.form.commonDistricts || this.form.commonDistricts.length === 0) {
                    return [];
                }
                return this.form.commonDistricts.reduce((acc, current) => {
                    const existingCity = acc.find(item => item.city_id === current.city_id);
                    if (existingCity) {
                        existingCity.commonDistricts.push(current);
                    } else {
                        acc.push({
                        province_id: current.province_id,
                        province_name: current.province_name,
                        city_id: current.city_id,
                        city_name: current.city_name,
                        commonDistricts: [current],
                        });
                    }
                    return acc;
                }, []);
            }
        },
        watch: {
           
        },
        methods: {
            resetForm() {
                this.list = [];
                this.form = {};
                this.searcheModel = {};
                this.getList(this.searcheModel);
            },

            handleCreate() {
                this.form = {
                    id: '',
                    districts: [],
                    district_ids: [],
                    commonDistricts: [],
                    common_district_ids: [],
                    user_id: '',
                };
                // 取消选择当前行
                this.$refs.areaTable.setCurrentRow(null);
            },

            getList(params) {
                this.loading = true;
                AreaUserService.getList(params).then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });

            },

            getSelectOptions() {
                UserService.getAll({
                    fields: "id,name",
                    scenario: "all-user"
                }).then(res => {
                    if (res.code == 0) {
                        this.users = res.data
                    }
                })
            },

            showView(row){
                this.$refs.areaTable.setCurrentRow(row);
                this.form = row;
                this.form.district_ids = this.form.districts.map(item => item.district_id);
                this.form.common_district_ids = this.form.commonDistricts.map(item => item.district_id);
            },

            areaTreeChange(val){
                this.$set(this.form, 'districts', val);
                this.form.district_ids = this.form.districts.map(item => item.district_id);
            },

            commonAreaTreeChange(val){
                this.$set(this.form, 'commonDistricts', val);
                this.form.common_district_ids = this.form.commonDistricts.map(item => item.district_id);
            },

            lockAllAreas(){
                if (!this.form.districts || this.form.districts.length === 0) {
                    this.$message({
                        message: "请选择绑定区域!",
                        type: "error",
                    });
                    return false;
                }
                this.form.districts.forEach(item => this.$set(item, 'is_lock', 1));
            },

            unlockAllAreas(){
                if (!this.form.districts || this.form.districts.length === 0) {
                    this.$message({
                        message: "请选择绑定区域!",
                        type: "error",
                    });
                    return false;
                }
                this.form.districts.forEach(item => this.$set(item, 'is_lock', 0));
            },

            unbindDistrict(district_id) {
                this.$confirm("确认要解绑该地区？", "温馨提示", {type: "warning"}).then(_ => {
                    this.form.districts = this.form.districts.filter(item => item.district_id !== district_id);
                    this.form.district_ids = this.form.districts.map(item => item.district_id);
                }).catch(err => {
                    console.error(err);
                    return;
                });
            },

            unbindCommonDistrict(district_id) {
                this.$confirm("确认要解绑该地区？", "温馨提示", {type: "warning"}).then(_ => {
                    this.form.commonDistricts = this.form.commonDistricts.filter(item => item.district_id !== district_id);
                    this.form.common_district_ids = this.form.commonDistricts.map(item => item.district_id);
                }).catch(err => {
                    console.error(err);
                    return;
                });
            },

            handleLock(item) {
                const targetDistrict = this.form.districts.find(district => district.district_id === item.district_id);
                if (targetDistrict) {
                    this.$set(targetDistrict, 'is_lock', !targetDistrict.is_lock);
                } else {
                    this.$message.error("未找到指定id的绑定区域!");
                }
            },

            handleDelete(row) {
                this.$confirm("确认要删除用户组吗？", "温馨提示", {type: "warning"}).then(_ => {
                    AreaUserService.delete(row.id).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: "删除成功!",
                                type: "success",
                            });
                            this.resetForm();
                        }else{
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    }).catch(err => {
                        console.error(err);
                    })
                }).catch(err => {
                    console.error(err);
                    return;
                });
            },
            handleSave() {
                if ((!this.form.districts || this.form.districts.length == 0) && (!this.form.commonDistricts || this.form.commonDistricts.length == 0)) {
                    this.$message({
                        message: "请选择绑定区域!",
                        type: "error",
                    });
                    return false;
                }
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submiting = true;
                        let area_group_service;
                        if(this.form.id > 0){
                            area_group_service = AreaUserService.update(this.form);
                        }else{
                            area_group_service = AreaUserService.create(this.form);
                        }
                        area_group_service.then(res => {
                            if (res && res.code == 0) {
                                this.$message({
                                    message: "保存成功!",
                                    type: "success",
                                });
                                this.resetForm();
                            }
                            this.submiting = false;
                        }).catch(err => {
                            this.submiting = false;
                            console.error(err);
                        })
                    } else {
                        console.log('error submit!!');
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/user/AreaUser.vue